import { render, staticRenderFns } from "./MultiNumber.vue?vue&type=template&id=2ee1d146"
import script from "./MultiNumber.vue?vue&type=script&lang=js"
export * from "./MultiNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports